import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  closeButton: {
    marginLeft: '8px',
    '& .MuiSvgIcon-root': {
      marginRight: '0px',
    },
  },
  labelRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '4px',
  },
  formLabel: {
    fontSize: '16px',
    fontWeight: foundations.typography.fontWeight.medium
  },
  characterCounter: {},
  publicationDescription: {
    marginTop: '16px',
  },
  descriptionTextField: {
    width: '100%',
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
      margin: 0,
      width: '100%',
    },
    '& .MuiInputBase-multiline': {
      width: '100%',
    },
  },
  copyOptionSelection: {
    marginTop: '16px'
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  radioButton: {
    '& input[type="radio"]': {
      display: 'none',
    },
  },
  warningContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    backgroundColor: foundations.colors.yellow50,
    border: `1px solid ${foundations.colors.yellow500}`,
    borderRadius: '3px',
    padding: '16px',
    marginTop: '12px',
    marginLeft: '32px',
    marginBottom: '16px'
  },
  warningIcon: {
    color: foundations.colors.yellow500,
    fontSize: '20px',
    flexShrink: 0
  },
  dialogActions: {
    justifyContent: 'flex-end',
    gap: '8px',
    padding: '16px 24px'
  }
});
